// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__xQpZ2","content":"styles_content__1yHo-","checkbox":"styles_checkbox__dQKp3","checkboxLabel":"styles_checkboxLabel__3cWjX"};